module.exports = __webpack_public_path__ + "static/media/atk.a6a96095.png";